import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter } from '@js/animations/scrollTriggerHelper'

export class TitleSeparator {
  constructor () {
    this._elements = document.querySelectorAll('.c-title--has-separator[animation-stagger]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      if (reduceMotion) {
        el.classList.add('c-title--separator-active')
        return
      }

      createOnceOnEnter({
        trigger: el,
        onEnter: () => {
          el.classList.add('c-title--separator-active')
        },
      })
    })
  }
}
